var jwt = require("jsonwebtoken")

export default class Utils
{
    static isAccesClient() {
        const subdomain = window.location.hostname.toLowerCase().split(".")
        return subdomain[1] === "backoffice" && subdomain[0] !== "dev"
    }

    static fromJWT(prop) {
        const data = jwt.decode(localStorage.JWT.split(' ')[1])
        return data[prop]
    }

    static isProd() {
        const serverName = this.fromJWT("serverName")
        if (serverName && serverName.includes("pprod")) {
            return false
        }

        return true
    }

    static isActivite(IDActivite) {
        return localStorage.activites && localStorage.activites.indexOf(IDActivite) !== -1
    }

    static isNissan() {
        const data = this.fromJWT("BDGp")
        if (data && data.includes("BDGpNi")) {
            return true
        }
        return false

    }

    static generateTooltips() {
        window.$('[data-toggle="tooltip"]').tooltip()
    }
}
